import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@/i18n';
import './index.css';
import App from './App.tsx';

async function bootstrap() {
  // Mocks are the default dev data source (no live backend assumed) — gated on DEV so a
  // production build never ships axios-mock-adapter. Once the real API is reachable, either
  // set VITE_USE_MOCKS=false in .env.local or delete this block.
  if (import.meta.env.DEV && import.meta.env.VITE_USE_MOCKS !== 'false') {
    const { installMockApi } = await import('./mocks/handlers');
    installMockApi();
  }

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void bootstrap();
